module.exports = {
  applicationFeeAssignmentType: {
    all: 'all',
    query: 'query',
  },
  applicationTemplateSources: {
    online: 'online',
    import: 'import',
  },
  applicationTemplateType: {
    application: 'application',
    inquiry: 'inquiry',
    supplemental: 'supplemental',
    aid: 'aid',
  },
  eedmDestinationModel: {
    applyApplications: 'apply-applications',
    applyProspectInquiries: 'apply-prospect-inquiries',
    aidApplications: 'aid-applications',
  },
  formTypeFlag: {
    isInquiry: 'isInquiry',
    isApplication: 'isApplication',
    isSupplemental: 'isSupplemental',
  },
  fraudStatus: {
    fraud: 'FRAUD',
    potential: 'POTENTIAL',
    noFraud: 'NOFRAUD',
    retry: 'RETRYFRAUD',
  },
  applicationPageStatuses: {
    COMPLETED: 'COMPLETED',
    NOTCOMPLETED: 'NOTCOMPLETED',
  },
  findOrCreateStatuses: {
      verifying: 'VERIFYING',
      matching: 'MATCHING',
      createError: 'CREATE_ERROR',
      unexpectedError: 'UNEXPECTED_ERROR',
      erpError: 'ERP_ERROR',
      complete: 'COMPLETED'
  },
  applicationProcessingStatus: {
    importError: 'IMPORT_ERROR',
    personCheck: 'PERSON_CHECK',
    personError: 'PERSON_ERROR',
    pending: 'PENDING',
    error: 'ERROR',
    integrationError: 'INTEGRATION_ERROR',
    complete: 'COMPLETE',
    fraud: 'FRAUD',
  },
  applicationTemplateRuleStatus: {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
  },
  supplementalItemTypes: {
    display: 'display',
    form: 'suppForm',
    formWithUpload: 'suppFormUpload',
    upload: 'upload',
  },
  supplementalAssignmentTypes: {
    always: 'always',
    conditionally: 'conditionally',
  },
  supplementalRequiredTypes: {
    always: 'always',
    conditionally: 'conditionally',
    optional: 'optional',
  },
  archiveErrorType: {
    supplemental: 'supplemental',
    application: 'application',
  },
  applicationSourceTypes: {
    selectedValue: 'selectedValue',
    textValue: 'textValue',
  },
  recaptchaActions: {
    retrieve: 'RETRIEVE',
    inquiry: 'INQUIRY',
    resend: 'RESEND',
  },
  emailVerificationStatus: {
    failed: 'FAILED',
    pending: 'PENDING',
    verified: 'VERIFIED',
  },
  controlTypes: {
    checkbox: 'checkbox',
    datepicker: 'datepicker',
    daterange: 'daterange',
    empty: 'empty',
    filteredsearch: 'filteredsearch',
    phone: 'phone',
    radiogroup: 'radiogroup',
    searchandselect: 'searchandselect',
    singlechoice: 'singlechoice',
    text: 'text',
    textarea: 'textarea',
  },
  errorType: {
    recaptcha: 'recaptcha',
    general: 'general',
  },
  pendingUpdates: {
    person: 'PERSON',
    application: 'APPLICATION'
  },
  personPipelineNames: [
    'apply-person-query-request',
    'apply-person-query',
    'app-processing-person-query-request',
    'app-processing-person-query',
 ],
  piiEedmMappings: {
    'apply-applications': [
      '/[credentials]/value',
      '/[alternativeCredentials]/value',
      '/citizenship/foreignTaxId',
      '/citizenship/visa/visaId',
      '/citizenship/visa/alienRegistrationNumber',
      '/citizenship/passportNumber',
      '/[disabilityTypes]',
      '/military/veteranFileNumber',
    ],
  },
  communicateEmailSendStatus: {
    accepted: 'ACCEPTED',
    failed: 'FAILED',
    postponed: 'POSTPONED ',
  },
  loginSources: {
    inquiry: 'inquiry',
    appRetreival: 'appRetrieval',
    mfaReset: 'mfaReset'
  },
  applicationAttributesForBothPersonAndApplication: [
    '/[parentsAndLegalGuardians]/address/addressType'
  ],
  applicationAttributesForPerson: [
    // Every field (regardless of ethos model) that goes into a find-or-create (person query request)
    '/name/type', '/name/title', '/name/firstName', '/name/middleName', '/name/lastNamePrefix', '/name/lastName',
    '/name/pedigree', '/name/preferredName',
    '/name/[alternateNames]/alternateNameType', '/name/[alternateNames]/alternateFirstName', '/name/[alternateNames]/alternateLastName',
    '/[addresses]/type', '/[addresses]/addressLine1', '/[addresses]/addressLine2', '/[addresses]/addressLine3', '/[addresses]/addressLine4',
    '/[addresses]/locality', '/[addresses]/region', '/[addresses]/subRegion', '/[addresses]/country', '/[addresses]/postalCode',
    '/[emails]/type', '/[emails]/address', '/[emails]/preference', '/[phones]/type',
    '/[phones]/number', '/[phones]/extension', '/[phones]/countryCallingCode',
    '/[credentials]/type', '/[credentials]/value',
    '/[alternativeCredentials]/type', '/[alternativeCredentials]/value',
    '/demographics/dateOfBirth', '/demographics/ethnicity', '/demographics/[races]', '/demographics/personalPronoun', '/demographics/maritalStatus',
    '/demographics/genderMarker', '/demographics/genderIdentity', '/demographics/gender',
    '/[emergencyContacts]/[types]', '/[emergencyContacts]/firstName', '/[emergencyContacts]/lastName', '/[emergencyContacts]/relationship',
    '/[emergencyContacts]/email', '/[emergencyContacts]/phoneNumber',
    '/[parentsAndLegalGuardians]/address/addressType', '/[parentsAndLegalGuardians]/address/addressLine1', '/[parentsAndLegalGuardians]/address/addressLine2',
    '/[parentsAndLegalGuardians]/address/addressLine3', '/[parentsAndLegalGuardians]/address/addressLine4', '/[parentsAndLegalGuardians]/address/locality',
    '/[parentsAndLegalGuardians]/address/subregion', '/[parentsAndLegalGuardians]/address/region', '/[parentsAndLegalGuardians]/address/postalCode',
    '/[parentsAndLegalGuardians]/address/country'
  ],
  personMatchLevel: {
    current: 'current',
    parent: 'parent',
  },
  hedmCustomFieldPath: '/[additionalData]/[propertyValues]',
  hedmModelCodeMappings: {
    'academic-credentials': {
      'codeField': 'abbreviation',
      'codeFieldPath': 'abbreviation'
    },
    'academic-disciplines': {
      'codeField': 'abbreviation',
      'codeFieldPath': 'abbreviation'
    },
    'academic-levels': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'academic-periods': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'academic-programs': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'address-types': {
      'codeField': 'addressType',
      'codeFieldPath': 'addressType'
    },
    'admission-application-influences': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'admission-application-types': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'admission-populations': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'alternative-credential-types': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'career-goals': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'citizenship-statuses': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'countries': {
      'codeField': 'isoCode',
      'codeFieldPath': 'isoCode'
    },
    'disability-types': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'educational-goals': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'educational-institutions': {
      'codeField': {
        'standardizedCodes': {
          'country': {
            'ceeb': true
          }
        }
      },
      'codeFieldPath': 'standardizedCodes.country.ceeb'
    },
    'email-types': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'ethnicities': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'genders': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'gender-identities': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'interests': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'languages': {
      'codeField': 'code',
      'codeFieldPath': 'code',
    },
    'marital-statuses': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'person-name-types': {
      'codeField': 'category',
      'codeFieldPath': 'category'
    },
    'personal-pronouns': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'phone-types': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'races': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'regions': {
      'codeField': 'isoCode',
      'codeFieldPath': 'isoCode'
    },
    'relationship-types': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'religions': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'residency-types': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'sites': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'subregions': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'veteran-statuses': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'visa-types': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    },
    'personal-relationship-types': {
      'codeField': 'code',
      'codeFieldPath': 'code'
    }
  },
  hedmCodeMappings: {
    /***Apply-Application*****/
    '/demographics/ethnicity': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'daPersonMappingField': 'title',
      'hasNoCode': true,
      'model': 'ethnicities'
    },
    '/demographics/[races]': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'daPersonMappingField': 'id',
      'model': 'races'
    },
    '/demographics/genderIdentity': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'gender-identities'
    },
    '/demographics/genderMarker': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'daPersonMappingField': 'title',
      'model': 'genders'
    },
    '/demographics/gender': {
      'codeField': 'title',
      'codeFieldPath': 'title',
      'daPersonMappingField': 'title',
      'model': 'genders'
    },
    '/demographics/personalPronoun': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'daPersonMappingField': 'id',
      'model': 'personal-pronouns'
    },
    '/demographics/maritalStatus': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'daPersonMappingField': 'title',
      'model': 'marital-statuses'
    },
    '/demographics/religiousAffiliation': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'religions'
    },
    '/[emails]/type': {
      'codeField': 'emailType',
      'codeFieldPath': 'emailType',
      'model': 'email-types'
    },
    '/[phones]/type': {
      'codeField': 'phoneType',
      'codeFieldPath': 'phoneType',
      'model': 'phone-types'
    },
    '/[addresses]/region': {
      'codeField': 'isoCode',
      'codeFieldPath': 'isoCode',
      'model': 'regions'
    },
    '/[addresses]/subRegion': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'subregions'
    },
    '/[addresses]/country': {
      'codeField': 'isoCode',
      'codeFieldPath': 'isoCode',
      'model': 'countries'
    },
    '/[addresses]/type': {
      'codeField': 'addressType',
      'codeFieldPath': 'addressType',
      'model': 'address-types'
    },
    '/name/type': {
      'codeField': 'category',
      'codeFieldPath': 'category',
      'model': 'person-name-types'
    },
    '/enrollment/academicLevel': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'academic-levels'
    },
    '/enrollment/[academicPrograms]': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'academic-programs'
    },
    '/enrollment/major': {
      'codeField': 'abbreviation',
      'codeFieldPath': 'abbreviation',
      'model': 'academic-disciplines'
    },
    '/enrollment/secondaryMajor': {
      'codeField': 'abbreviation',
      'codeFieldPath': 'abbreviation',
      'model': 'academic-disciplines'
    },
    '/enrollment/minor': {
      'codeField': 'abbreviation',
      'codeFieldPath': 'abbreviation',
      'model': 'academic-disciplines'
    },
    '/enrollment/concentration': {
      'codeField': 'abbreviation',
      'codeFieldPath': 'abbreviation',
      'model': 'academic-disciplines'
    },
    '/enrollment/academicPeriod': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'academic-periods'
    },
    '/enrollment/studentType': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'admission-populations'
    },
    '/enrollment/[campusLocations]': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'sites'
    },
    '/enrollment/admissionType': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'admission-application-types'
    },
    '/enrollment/[educationalGoals]': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'educational-goals'
    },
    '/citizenship/citizenshipStatus': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'citizenship-statuses'
    },
    '/citizenship/visa/visaType': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'visa-types'
    },
    '/citizenship/visa/countryOfBirth': {
      'codeField': 'isoCode',
      'codeFieldPath': 'isoCode',
      'model': 'countries'
    },
    '/citizenship/countryOfBirth': {
      'codeField': 'isoCode',
      'codeFieldPath': 'isoCode',
      'model': 'countries'
    },
    '/citizenship/nativeLanguage': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'languages'
    },
    '/citizenship/primaryLanguage': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'languages'
    },
    '/citizenship/[secondaryLanguages]': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'languages'
    },
    '/citizenship/[countryOfCitizenship]': {
      'codeField': 'isoCode',
      'codeFieldPath': 'isoCode',
      'model': 'countries'
    },
    '/citizenship/passportNationOfIssue': {
      'codeField': 'isoCode',
      'codeFieldPath': 'isoCode',
      'model': 'countries'
    },
    '/military/veteranStatus': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'veteran-statuses'
    },
    '/[alternativeCredentials]/type': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'daPersonMappingField': 'id',
      'model': 'alternative-credential-types'
    },
    '/[secondarySchools]/institution': {
      'codeField': {
        'standardizedCodes': {
          'country': {
            'ceeb': true
          }
        }
      },
      'codeFieldPath': 'standardizedCodes.country.ceeb',
      'model': 'educational-institutions'
    },
    '/[previousInstitutions]/institution': {
      'codeField': {
        'standardizedCodes': {
          'country': {
            'ceeb': true
          }
        }
      },
      'codeFieldPath': 'standardizedCodes.country.ceeb',
      'model': 'educational-institutions'
    },
    '/[previousInstitutions]/credentialReceived': {
      'codeField': 'abbreviation',
      'codeFieldPath': 'abbreviation',
      'model': 'academic-credentials'
    },
    '/[parentsAndLegalGuardians]/relationship': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'relationship-types'
    },
    '/[parentsAndLegalGuardians]/address/addressType': {
        'codeField': 'addressType',
        'codeFieldPath': 'addressType',
        'model': 'address-types'
    },
    '/[parentsAndLegalGuardians]/address/region': {
      'codeField': 'isoCode',
      'codeFieldPath': 'isoCode',
      'model': 'regions'
    },
    '/[parentsAndLegalGuardians]/address/subregion': {
      'codeField': 'isoCode',
      'codeFieldPath': 'isoCode',
      'model': 'subregions'
    },
    '/[parentsAndLegalGuardians]/address/country': {
      'codeField': 'isoCode',
      'codeFieldPath': 'isoCode',
      'model': 'countries'
    },
    '/residencyType': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'residency-types'
    },
    '/[interests]': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'interests'
    },
    '/[disabilityTypes]': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'disability-types'
    },
    '/[emergencyContacts]/[types]': {
      'codeField': 'id',
      'codeFieldPath': 'id',
      'daPersonMappingField': 'title',
      'hasNoCode': true,
      'model': 'emergency-contact-types'
    },
    '/[emergencyContacts]/relationship': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'daPersonMappingField': 'title',
      'model': 'relationship-types'
    },
    '/[careerGoals]': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'career-goals'
    },
    '/[decisionFactors]': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'admission-application-influences'
    },
    /***Apply-Prospect-Inquiries*****/
    '/entryAcademicPeriod': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'academic-periods'
    },
    '/academicLevel': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'academic-levels'
    },
    '/[academicPrograms]': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'academic-programs'
    },
    '/major': {
      'codeField': 'abbreviation',
      'codeFieldPath': 'abbreviation',
      'model': 'academic-disciplines'
    },
    '/site': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'sites'
    },
    '/admissionPopulation': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'admission-populations'
    },
    '/residency-types': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'residency-types'
    },
    '/citizenshipStatus': {
      'codeField': 'code',
      'codeFieldPath': 'code',
      'model': 'citizenship-statuses'
    }
  }
};
